import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import TroubleshootingPage from './TroubleshootingPage';

const TroubleshootingRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    console.log('TroubleshootingRoutes path', path);
    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={TroubleshootingPage} />
            </Switch>
        </>
    );
};

export default TroubleshootingRoutes;
